module.exports = __webpack_public_path__ + "static/annotations-f0f48efb81c1e0b771b39b3f25dcc848.png";